import * as React from 'react'
import { useKey } from 'react-use'
import { useTranslation } from 'hooks'
import { iconCrossM } from 'images'
import { ModalProps } from './Modal.types'
import * as S from './Modal.styles'

const Modal: React.FC<React.PropsWithChildren<ModalProps>> = ({
  children,
  toggleModal,
  css,
  closeOnClickOutside = true,
  closeOnButton = true,
  closeOnEsc = true,
  ...rest
}) => {
  const { t } = useTranslation()

  useKey('Escape', () => closeOnEsc && toggleModal())

  return (
    <S.StyledModal {...rest} role="presentation">
      <S.ModalBackdrop onClick={() => closeOnClickOutside && toggleModal()}>
        <S.ModalContent
          role="presentation"
          onClick={(e) => e.stopPropagation()}
          onTouchMove={(e) => e.stopPropagation()}
          style={css}
        >
          {closeOnButton && (
            <S.ModalClose onClick={toggleModal}>
              <img src={iconCrossM} alt={t('shared.close')} />
            </S.ModalClose>
          )}

          {children}
        </S.ModalContent>
      </S.ModalBackdrop>
    </S.StyledModal>
  )
}

export default Modal
